/* ═══════════════════════════════════════════════════
   NEWJAISA — BFSI INDUSTRY PAGE
   File: assets/component-bfsi.js
   Namespace: BfsiPage · No globals · No jQuery
═══════════════════════════════════════════════════ */

'use strict';

var BfsiPage = (function () {

  function $(id)   { return document.getElementById(id); }
  function $$(sel) { return Array.from(document.querySelectorAll(sel)); }

  /* ── FAQ ACCORDION ──────────────────────────── */
  function initFAQ() {
    $$('.bfsi-faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.bfsi-faq-item');
        if (!item) return;
        var isOpen = item.classList.contains('open');

        /* Close all open items */
        $$('.bfsi-faq-item.open').forEach(function (i) {
          i.classList.remove('open');
          var q = i.querySelector('.bfsi-faq-q');
          if (q) q.setAttribute('aria-expanded', 'false');
        });

        /* Open clicked (unless already open) */
        if (!isOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── SCROLL REVEAL ──────────────────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.bfsi-reveal').forEach(function (el) { el.classList.add('bfsi-vis'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var parent   = entry.target.parentElement;
        var siblings = parent
          ? Array.from(parent.children).filter(function (el) {
              return el.classList.contains('bfsi-reveal') && !el.classList.contains('bfsi-vis');
            })
          : [];
        var idx = siblings.indexOf(entry.target);
        setTimeout(function () {
          entry.target.classList.add('bfsi-vis');
        }, Math.max(0, idx * 80));
        io.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    $$('.bfsi-reveal').forEach(function (el) { io.observe(el); });
  }

  /* ── SMOOTH ANCHOR SCROLL ───────────────────── */
  function initAnchors() {
    $$('a[href="#bfsi-cta"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var el = document.getElementById('bfsi-cta');
        if (!el) return;
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ── COMPLIANCE DOC DOWNLOADS ───────────────── */
  function initDownloads() {
    function notify(name) {
      alert('Downloading: ' + name + '\n\nContact business@newjaisa.com to receive the full compliance documentation pack.');
    }

    var dlDeck   = $('bfsi-dl-deck');
    var dlBanner = $('bfsi-dl-banner');
    var dlFull   = $('bfsi-dl-full');

    if (dlDeck)   dlDeck.addEventListener('click',   function () { notify('BFSI Compliance Deck'); });
    if (dlBanner) dlBanner.addEventListener('click', function () { notify('BFSI Compliance Pack'); });
    if (dlFull)   dlFull.addEventListener('click',   function () { notify('Full BFSI Compliance Pack'); });

    $$('.bfsi-ds-item').forEach(function (item) {
      item.addEventListener('click', function () {
        notify(item.getAttribute('data-doc') || 'BFSI Document');
      });
    });
  }

  /* ── INIT ───────────────────────────────────── */
  function init() {
    initFAQ();
    initReveal();
    initAnchors();
    initDownloads();
  }

  return { init: init };

})();

document.addEventListener('DOMContentLoaded', function () {
  BfsiPage.init();
});
